import { render } from "./grid.vue?vue&type=template&id=c27a84cc"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"
script.render = render

export default script